import { Icon } from "grabcad-ui-elements";
import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 6px;
`;

export const LabelWrapper = styled.div`
    align-self: stretch;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 6px;
`;

export const Label = styled.div`
    color: #4a5565;
    font-size: 14px;
    font-family: Inter, sans-serif;
    font-weight: 400;
    line-height: 20px;
`;

export const InfoTooltip = styled.div`
    position: absolute;
    z-index: 1000;

    left: calc(100% + 8px);
    top: 50%;
    transform: translateY(-50%);

    width: 320px;
    max-width: 320px;

    padding: 10px 12px;

    background: #333;
    border-radius: 4px;

    color: #fff;
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;

    white-space: normal;
    text-align: left;

    opacity: 0;
    visibility: hidden;

    transition: opacity 0.15s ease, visibility 0.15s ease;

    pointer-events: none;

    &::before {
        content: "";
        position: absolute;

        top: 50%;
        right: 100%;

        transform: translateY(-50%);

        border-width: 6px;
        border-style: solid;
        border-color: transparent #333 transparent transparent;
    }
`;

export const InfoIconWrapper = styled.span`
    position: relative;
    display: inline-flex;
    align-items: center;

    &:hover ${/* sc-selector */ InfoTooltip} {
        opacity: 1;
        visibility: visible;
    }

    &:focus-within ${/* sc-selector */ InfoTooltip} {
        opacity: 1;
        visibility: visible;
    }
`;

export const InfoIcon = styled(Icon)`
    cursor: pointer;
    margin-top: 8px;

    &.large.icon {
        font-size: 14px !important;
    }
`;

export const InputRow = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
`;

export const InputContainer = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 320px;

    height: 40px;
    padding: 0 12px;

    border: 1px solid #d6d6d6;
    border-radius: 10px;
    gap: 10px;

    background: #fafafa;
    color: #1d1d1f;

    font-size: 14px;
    outline: none;

    display: flex;
    align-items: center;
    box-sizing: border-box;
    &:disabled {
        cursor: not-allowed;
        opacity: 1;
        background: #ffffff;
        color: #6b6b6b;
    }

    @media (max-width: 768px) {
        height: 40px;
        padding: 0 10px;
    }

    @media (max-width: 480px) {
        height: 38px;
        padding: 0 8px;
        font-size: 13px;
    }
`;

export const EyeButton = styled.button`
    padding: 0;
    margin: 0;
    border: 0;
    background: transparent;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
`;

export const EditButton = styled.button`
    padding: 0;
    margin: 0;
    border: 0;
    background: transparent;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
`;

export const EyeIcon = styled.span`
    width: 15px;
    height: 15px;
    position: relative;
    display: block;

    &::before {
        content: "";
        width: 13px;
        height: 9px;
        left: 1px;
        top: 3px;
        position: absolute;

        border: 1.3px solid #99a1af;
        border-radius: 50% / 60%;
    }

    &::after {
        content: "";
        width: 3.6px;
        height: 3.6px;
        left: 5.7px;
        top: 5.7px;
        position: absolute;

        border: 1.3px solid #99a1af;
        border-radius: 50%;
    }
`;

export const CopyButton = styled.button`
    width: 32px;
    height: 32px;
    padding: 0;

    border: 0;
    background: transparent;
    border-radius: 8px;

    outline: 1.2px solid #e5e7eb;
    outline-offset: -1.2px;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;

    &:hover {
        background: #f9fafb;
    }
`;

export const EditIcon = styled.img`
    width: 18px;
    height: 18px;
    object-fit: contain;
    cursor: pointer;
`;

export const InputField = styled.input<{ $masked?: boolean }>`
    flex: 1;
    min-width: 0;
    border: 0;
    border-radius: 0;
    padding: 0;
    font-size: 14px;
    font-family: Inter, sans-serif;
    background: transparent;
    color: #6a7282;
    outline: none;
    letter-spacing: ${(props) => (props.$masked ? "1.4px" : "normal")};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:focus {
        box-shadow: none;
    }
`;

export const ActionButtonGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ActionButton = styled.button`
    min-width: 28px;
    height: 28px;
    border: 1px solid #d6d6d6;
    background: #fff;
    border-radius: 8px;
    padding: 0;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.7;
    }
`;
